__turbopack_context__.v({
  "pulse": "_5DvgmW_pulse",
  "skeleton": "_5DvgmW_skeleton",
});
